import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  content: {
    marginTop: '2rem',
  },
  contentWrapper: {
    padding: 0,
  },
  modal: {
    width: '100%',
  },
  modalButton: {
    position: 'absolute',
    right: 0,
  },
  paper: {
    background: `rgb(${theme.palette.black})`,
  },
}))

export default useStyles
